import { useSolubilityStore, TRIAL_PRESETS, TrialId } from '../store/useSolubilityStore';

const sleep = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms));

async function waitFor(predicate: () => boolean, timeoutMs = 30000, intervalMs = 100) {
  const start = Date.now();
  while (!predicate()) {
    if (!useSolubilityStore.getState().isAutoDemoRunning) return false;
    if (Date.now() - start > timeoutMs) return false;
    await sleep(intervalMs);
  }
  return true;
}

export async function runAutoDemo() {
  const store = useSolubilityStore.getState();
  if (store.isAutoDemoRunning) return;

  store.resetAll();
  store.setAutoDemoRunning(true);
  store.setSimulationSpeed(10);

  try {
    for (const id of [1, 2, 3] as TrialId[]) {
      if (!useSolubilityStore.getState().isAutoDemoRunning) return;
      const preset = TRIAL_PRESETS[id];

      useSolubilityStore.getState().selectTrial(id);
      await sleep(400);

      useSolubilityStore.getState().pourWater();
      await waitFor(() => !useSolubilityStore.getState().isPouringWater);
      await sleep(200);

      for (let i = 0; i < 8; i++) {
        if (!useSolubilityStore.getState().isAutoDemoRunning) return;
        useSolubilityStore.getState().weighSaltStep();
        await sleep(140);
      }

      useSolubilityStore.getState().addSaltToBeaker();
      await waitFor(() => !useSolubilityStore.getState().isTransferringSalt);
      await sleep(200);

      if (preset.needsHeating) {
        useSolubilityStore.getState().toggleHeating();
        await waitFor(() => useSolubilityStore.getState().waterTempC >= preset.targetTempC - 1);
        if (!useSolubilityStore.getState().isAutoDemoRunning) return;
        useSolubilityStore.getState().toggleHeating();
        await sleep(200);
      }

      useSolubilityStore.getState().setStirring(true);
      await waitFor(() => useSolubilityStore.getState().stirSeconds >= 120);
      if (!useSolubilityStore.getState().isAutoDemoRunning) return;
      useSolubilityStore.getState().setStirring(false);
      await sleep(300);

      useSolubilityStore.getState().recordObservation();
      await sleep(600);
    }
  } finally {
    useSolubilityStore.getState().setAutoDemoRunning(false);
    useSolubilityStore.getState().setSimulationSpeed(1);
  }
}

export function stopAutoDemo() {
  useSolubilityStore.getState().setAutoDemoRunning(false);
}
